(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["club-dashboard"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeDashboard = (dashboard) => {
      if (dashboard.dataset.clubDashboardReady === 'true') return;
      dashboard.dataset.clubDashboardReady = 'true';

      const tabs = Array.from(dashboard.querySelectorAll('[data-club-tab]'));
      const panels = Array.from(dashboard.querySelectorAll('[data-club-panel]'));

      const activate = (name, updateHash = true) => {
        const activeTab = tabs.find((tab) => tab.dataset.clubTab === name);
        const activePanel = panels.find((panel) => panel.dataset.clubPanel === name);
        if (!activeTab || !activePanel) return;

        tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel !== activePanel;
        });

        activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

        if (updateHash && window.history?.replaceState) {
          window.history.replaceState(null, '', `#club-${name}`);
        }
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.clubTab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          activate(tabs[nextIndex].dataset.clubTab);
          tabs[nextIndex].focus();
        });
      });

      dashboard.querySelectorAll('[data-club-open]').forEach((trigger) => {
        trigger.addEventListener('click', () => activate(trigger.dataset.clubOpen));
      });

      const requestedPanel = window.location.hash.replace('#club-', '');
      if (panels.some((panel) => panel.dataset.clubPanel === requestedPanel)) {
        activate(requestedPanel, false);
      }
    };

    const initializeAllDashboards = (root = document) => {
      root.querySelectorAll('[data-club-dashboard]').forEach(initializeDashboard);
    };

    initializeAllDashboards();
    document.addEventListener('shopify:section:load', (event) => initializeAllDashboards(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["club-magazine"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('club-editorial-slider')) {
    class ClubEditorialSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-editorial-slide]'));
        this.currentIndex = 0;
        this.paused = false;
        this.interval = Math.max(600, Number.parseInt(this.dataset.interval, 10) || 1000);
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.handleMotionChange = this.handleMotionChange.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);

        if (this.slides.length < 2) return;

        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.motionPreference.addEventListener('change', this.handleMotionChange);
        this.scheduleNextFrame();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.motionPreference?.removeEventListener('change', this.handleMotionChange);
      }

      showFrame(index) {
        this.slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === index);
        });
        this.currentIndex = index;
      }

      scheduleNextFrame() {
        window.clearTimeout(this.timer);

        if (this.paused || this.motionPreference.matches || document.hidden) return;

        this.timer = window.setTimeout(() => {
          this.showFrame((this.currentIndex + 1) % this.slides.length);
          this.scheduleNextFrame();
        }, this.interval);
      }

      handleVisibilityChange() {
        this.scheduleNextFrame();
      }

      handleMotionChange() {
        if (this.motionPreference.matches) this.showFrame(0);
        this.scheduleNextFrame();
      }

      handleBlockSelect(event) {
        const selectedSlide = event.target.closest('[data-editorial-slide]');
        const selectedIndex = this.slides.indexOf(selectedSlide);

        if (selectedIndex < 0) return;

        this.paused = true;
        this.showFrame(selectedIndex);
        this.scheduleNextFrame();
      }
    }

    customElements.define('club-editorial-slider', ClubEditorialSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function attachCheckboxListener() {
  var checkbox = document.getElementById('signup-checkbox-footer');
  var submitButton = document.getElementById('FooterSubscribe');

  if (checkbox && submitButton) {
    checkbox.removeEventListener('change', toggleSubmitButton);
    checkbox.addEventListener('change', toggleSubmitButton);

    submitButton.disabled = !checkbox.checked;
  }
}

function toggleSubmitButton() {
  var submitButton = document.getElementById('FooterSubscribe');
  if (submitButton) {
    submitButton.disabled = !this.checked;
  }
}

document.addEventListener('DOMContentLoaded', attachCheckboxListener);
document.addEventListener('shopify:section:select', attachCheckboxListener);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    const marginDesktopValue = this.getAttribute('data-margin-desktop');
    // Fetch data-margin-desktop and calculate percentage
    this.marginDesktopPercentage = parseFloat(marginDesktopValue) || 2; 
    this.marginDesktopThreshold = this.marginDesktopPercentage*2 / 100; 

    const marginMobileValue = this.getAttribute('data-margin-mobile');
    this.marginMobilePercentage = parseFloat(marginMobileValue) || 2; 
    this.marginMobileThreshold = this.marginMobilePercentage / 300; 

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 250; 
    const viewportWidth = window.innerWidth;
    let resetOffset;

    if (viewportWidth < 990) {
      resetOffset = window.innerHeight * this.marginMobileThreshold;
    } else {
      // Using desktop threshold
      resetOffset = window.innerHeight * this.marginDesktopThreshold;
    }
    
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top + resetOffset) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  function initIntersectionObserver() {
  const headers = document.querySelectorAll('.enable-fixed-header-part--true.enable-header-full-width--false');

  if (!headers.length) return; // Ensure there are elements to observe

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); 
      }
    });
  }, { threshold: 1 });

  headers.forEach(header => {
    observer.observe(header);
  });
}

initIntersectionObserver();

document.addEventListener('shopify:section:load', () => {
  initIntersectionObserver();
});


  } catch(e) { console.error(e); }
})();
})();
